<template>
  <nav
    v-if="items.length > 0"
    class="t-breadcrumb flex py-4 md:py-7"
    :aria-label="t('menu.breadcrumb.breadcrumb')"
  >
    <ol class="flex items-center m-0">
      <template v-if="items.length > 2">
        <li aria-hidden="true" class="block md:hidden">
          <div class="flex items-center">
            <span class="text-xs font-bold text-gray-500 no-underline"
              >...</span
            >
          </div>
        </li>
      </template>

      <template v-for="(item, index) in items" :key="index">
        <li
          :class="{
            hidden: index < items.length - 2,
            'md:block': index < items.length - 2,
          }"
        >
          <div class="flex items-center">
            <svg
              v-if="index > 0"
              class="mx-1 h-5 w-5 shrink-0 text-gray-500"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                clip-rule="evenodd"
              />
            </svg>

            <a
              v-if="item.url"
              class="text-xs font-bold text-gray-500 hover:text-gray-700 no-underline transition ease-in-out duration-300"
              aria-current="page"
              :href="item.url"
            >
              {{ item.name }}
            </a>
            <span v-else class="text-xs font-bold text-gray-700 no-underline">
              {{ item.name }}
            </span>
          </div>
        </li>
      </template>
    </ol>
  </nav>
</template>

<script setup lang="ts">
export interface TBreadcrumb_Props {
  items: Array<{
    name: string
    url?: string
  }>
}

defineProps<TBreadcrumb_Props>()
</script>
